import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';

import { PipeModule } from 'presentation/common/pipe/pipe.module';
import { CoacheeProfileInformationComponent } from 'presentation/page/profile/coachee-profile/coachee-profile-information/coachee-profile-information.component';

import { AppSharedModule } from '../../../../../app-shared.module';
import { CoacheeProfileInformationActivitiesComponent } from './coachee-profile-information-activities/coachee-profile-information-activities.component';
import { CoacheeProfileInformationDetailsComponent } from './coachee-profile-information-details/coachee-profile-information-details.component';

@NgModule({
	declarations: [
		CoacheeProfileInformationComponent,
		CoacheeProfileInformationDetailsComponent,
		CoacheeProfileInformationActivitiesComponent,
	],
	imports: [
		TableModule,
		DropdownModule,
		CalendarModule,
		InputTextModule,
		ReactiveFormsModule,
		CommonModule,
		TranslateModule,
		PipeModule,
		MultiSelectModule,
		NgScrollbarModule,
		CardModule,
		AppSharedModule,
	],
	exports: [CoacheeProfileInformationComponent],
	providers: [],
})
export class CoacheeProfileInformationModule {}
